import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBarge",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], h = ["clip-path"], u = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.5 2a.5.5 0 0 0-.5.5V4a.5.5 0 1 1-1 0V2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5V8a.5.5 0 0 1 1 0v1.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm3.455 1.838a.5.5 0 0 1 .707 0L8.47 5.647a.5.5 0 0 1 0 .707L6.662 8.162a.5.5 0 0 1-.707-.707l.954-.955H.5a.5.5 0 0 1 0-1h6.41l-.955-.954a.5.5 0 0 1 0-.708Z",
  "clip-rule": "evenodd"
}, null, -1), f = [
  u
], m = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(e, I, r, b, q, t) {
  return n(), l("svg", {
    "aria-label": r.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--barge"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Barge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, f, 8, h),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, _);
}
const B = /* @__PURE__ */ s(c, [["render", v]]);
export {
  B as default
};
//# sourceMappingURL=barge.js.map
